<template>
  <el-dialog
    class="dialog"
    title="添加发送对象"
    width="680px"
    :visible.sync="showAddPerson.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
    @close="close"
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :model="form"
      ref="form"
      :rules="rules"
    >
      <el-form-item label="手机号码：" prop="mobile">
        <el-input placeholder="请输入手机号码" v-model="form.mobile" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <butn
        class="czButn"
        @click="close"
        size="small"
        title="取 消"
      />
      <butn btntype="primary" @click="confirm" size="small" title="提 交" />
    </span>
  </el-dialog>
</template>

<script>
import vue from "@/main";
import { validMobile } from "@/utils/rules/validMobile.js";
import butn from "@/components/button/index";
export default {
  components: { butn },
  props: {
    showAddPerson: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        mobile: ""
      },
      rules: {
        mobile: [
          {
            required: true,
            validator: validMobile,
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  created() {
  },
  methods: {
    confirm() {
      this.$refs["form"].validate(res => {
        if (res) {
          this.$emit("addPersonHandle", {
            userMobile: this.form.mobile
          });
        }
      });
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  /deep/ .el-form-item:last-child {
    margin-top: 30px !important;
  }
}
</style>
